import { render, staticRenderFns } from "./reservationDetail.vue?vue&type=template&id=5c714a9c&scoped=true"
import script from "./reservationDetail.vue?vue&type=script&lang=js"
export * from "./reservationDetail.vue?vue&type=script&lang=js"
import style0 from "./reservationDetail.vue?vue&type=style&index=0&id=5c714a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c714a9c",
  null
  
)

export default component.exports